<template>
  <div>
    <pn-modal label="Update Value" @close="onClose" :open="open">
      <div :class="[{ spinner: showSpinner }]">
        <pn-spinner size="3" v-show="showSpinner" />
      </div>
      <form class="modal-default">
        <div>
          <span class="font-bold">Key: </span><span> {{ editConfig.key }}</span>
        </div>
        <pn-input
          label="Value"
          name="value"
          v-model="editConfig.value"
        ></pn-input>
      </form>
      <div slot="buttons">
        <pn-button label="Save" @click="onConfirm"></pn-button>
      </div>
    </pn-modal>
  </div>
</template>

<script setup lang="ts">
import { reactive, watch } from "vue";

const props = withDefaults(
  defineProps<{
    open: boolean;
    showSpinner: boolean;
    config: Record<string, string>;
  }>(),
  {
    open: false,
    showSpinner: false,
  },
);

const editConfig = reactive({ ...props.config });

const emit = defineEmits<{
  (e: "onClose"): void;
  (e: "onConfirm", updatedConfig: Record<string, any>): void;
}>();

const onClose = () => {
  emit("onClose");
};
const onConfirm = () => {
  emit("onConfirm", editConfig);
};

watch(
  () => props.config,
  (updatedconfig) => {
    Object.assign(editConfig, updatedconfig);
  },
);
</script>

<style scoped></style>
